import BN from 'bignumber.js';
import Decimal from 'decimal.js';
var RAY = new BN(Math.pow(10, 27));
var SECONDS_PER_YEAR = 31536000;
export var getAssetRateByApy = function (_a) {
    var apy = _a.apy;
    var APYDecimal = new Decimal(apy).div(100);
    var rate = APYDecimal.plus(1)
        .pow(new Decimal(1).div(SECONDS_PER_YEAR))
        .minus(1)
        .times(SECONDS_PER_YEAR)
        .mul(new Decimal(RAY.toString()));
    return { rate: rate.toFixed() };
};
